// src/components/ProtectedRoute.jsx
// ======================================================
// ✅ ProtectedRoute – Control de Acceso Autenticado
// Evalúa Salud IPS
// ======================================================

import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { autenticado, cargando } = useAuth();
  const location = useLocation();

  if (cargando) {
    return (
      <div
        role="status"
        aria-live="polite"
        style={{
          padding: "2rem",
          textAlign: "center",
          color: "#004aad",
          fontFamily: "'Segoe UI', Roboto, sans-serif"
        }}
      >
        Verificando sesión…
      </div>
    );
  }

  if (!autenticado) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};
